import { NodeSelection } from './../../selection/index';
import * as EVENTS from './../../common/constant';
import { InsertHtml } from './inserthtml';
import { closest } from '@syncfusion/ej2-base';
export class EmojiPickerAction {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    addEventListener() {
        this.parent.observer.on(EVENTS.EMOJI_PICKER_ACTIONS, this.emojiInsert, this);
        this.parent.observer.on(EVENTS.INTERNAL_DESTROY, this.destroy, this);
    }
    removeEventListener() {
        this.parent.observer.off(EVENTS.EMOJI_PICKER_ACTIONS, this.emojiInsert);
        this.parent.observer.off(EVENTS.INTERNAL_DESTROY, this.destroy);
    }
    emojiInsert(args) {
        const node = document.createTextNode(args.value);
        const selection = this.parent.currentDocument.getSelection();
        const range = selection.getRangeAt(0);
        const cursorPos = range.startOffset;
        for (let i = cursorPos - 1; i >= cursorPos - 15; i--) {
            const prevChar = selection.focusNode.textContent.substring(i - 1, i);
            const isPrevSpace = /:$/.test(prevChar);
            if (isPrevSpace) {
                this.beforeApplyFormat(true);
                break;
            }
        }
        const colon = /:$/.test(selection.focusNode.textContent.charAt(cursorPos - 1));
        const prevChar = selection.focusNode.textContent.charAt(cursorPos - 2);
        const isPrevSpace = /\s/.test(prevChar);
        if (colon && (isPrevSpace || selection.focusOffset === 1)) {
            this.beforeApplyFormat(true);
        }
        const focusNode = selection.focusNode;
        const anchorParent = closest(focusNode.nodeName === '#text' ? focusNode.parentNode : focusNode, 'a');
        if (anchorParent) {
            if (cursorPos === 0) {
                // Insert emoji before the anchor tag if at the start
                anchorParent.parentNode.insertBefore(node, anchorParent);
            }
            else if (cursorPos === focusNode.textContent.length) {
                // Insert emoji after the anchor tag if at the end
                anchorParent.parentNode.insertBefore(node, anchorParent.nextSibling);
                const nodeSelection = new NodeSelection(anchorParent);
                // eslint-disable-next-line max-len
                nodeSelection.setCursorPoint(this.parent.currentDocument, anchorParent.nextSibling, anchorParent.nextSibling.textContent.length);
            }
        }
        else {
            InsertHtml.Insert(this.parent.currentDocument, node, this.parent.editableElement);
        }
        if (args.callBack) {
            args.callBack({
                requestType: args.subCommand,
                editorMode: 'HTML',
                event: args.event,
                range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
            });
        }
    }
    beforeApplyFormat(isBlockFormat) {
        const range1 = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        const node = this.parent.nodeSelection.getNodeCollection(range1)[0];
        const blockNewLine = !(node.parentElement.innerHTML.replace(/&nbsp;|<br>/g, '').trim() === ':' || node.textContent.trim().indexOf('/') === 0);
        let startNode = node;
        if (blockNewLine && isBlockFormat) {
            while (startNode !== this.parent.editableElement) {
                startNode = startNode.parentElement;
            }
        }
        let startPoint = range1.startOffset;
        while (this.parent.nodeSelection.getRange(this.parent.editableElement.ownerDocument).toString().indexOf(':') === -1) {
            this.parent.nodeSelection.setSelectionText(this.parent.editableElement.ownerDocument, node, node, startPoint, range1.endOffset);
            startPoint--;
        }
        const range2 = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        const node2 = this.parent.nodeCutter.GetSpliceNode(range2, node);
        node2.parentNode.removeChild(node2);
    }
    destroy() {
        this.removeEventListener();
    }
}
